<template>
    <common-page flex-column card-content>
        <query-view ref="queryView" config-code="sith_mes_tpm_opc_curve_query" with-custom-actions-head-of-row>
            <template #leftHeader>
                <b-button size="sm" variant="outline-primary" class="mr-1" @click="openCreate">
                    <i class="fa-solid fa-plus"></i> {{ $t('label.sith.tpm.furnaceHeatOrder.add') }}
                </b-button>
                <b-button size="sm" variant="outline-primary" class="mr-1" :disabled="checkedRows.length !== 1" @click="openEdit">
                    <i class="fa-solid fa-pen-to-square"></i> {{ $t('label.sith.tpm.furnaceHeatOrder.edit') }}
                </b-button>
                <b-button size="sm" variant="outline-danger" class="mr-1" :disabled="!checkedRows.length || deleting" @click="deleteChecked">
                    <i class="fa fa-fw" :class="deleting ? 'fa-spinner fa-spin' : 'fa-trash'"></i>{{ $t('label.sith.tpm.furnaceHeatOrder.delete') }}
                </b-button>
            </template>
            <template #headOfRow="{row}">
                <b-button size="sm" variant="link" class="p-0 text-nowrap" @click="viewCurve(row)">
                    <i class="fa fa-fw fa-line-chart"></i>{{ $t('label.sith.tpm.furnaceHeatOrder.viewCurve') }}
                </b-button>
            </template>
        </query-view>
        <furnace-heat-order-modal ref="modal" @saved="refresh"></furnace-heat-order-modal>
    </common-page>
</template>

<script>
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";
import QueryView from "@/components/common/display/query-view/QueryView.vue";
import FurnaceHeatOrderModal from "@/components/SithMes/tpm/furnaceHeatOrder/FurnaceHeatOrderModal.vue";
import {deleteRecord} from "@/components/SithMes/tpm/opcCurve/opcCurveQueryApi";
import miniTableCheckedMixin from "@/mixin/em/common/stuffs/table/miniTableCheckedMixin";

const CONFIG_CODE = 'sith_mes_tpm_opc_curve_query';

/**
 * 炉子加热工单（spec 2026-10-26-furnace-heat-order-design.md 验收 #1–#7）。
 * 列表 / 筛选 / 导出来自 QueryView 配置 sith_mes_tpm_opc_curve_query
 * （src/model/sithMes/tpm/SithMesTpmOpcCurveQuery.jsc-import.json，service = sith-mes，需在 /query/config/table 导入）。
 * QueryView 自带编辑关闭：编号与校验必须走后端 /sithMesTpmOpcCurveQuery/create|update。
 * 「查看曲线」跳 OPC 点位曲线页 ?recordId=。
 */
export default {
    name: "SithMesTpmFurnaceHeatOrder",
    mixins: [miniTableCheckedMixin],
    components: {CommonPage, QueryView, FurnaceHeatOrderModal},
    data() {
        return {deleting: false};
    },
    computed: {
        // miniTableCheckedMixin 按它从 queryViewStore 取本 QueryView 的勾选（checkedRows / checkedRow）
        $_configCode() {
            return CONFIG_CODE;
        }
    },
    methods: {
        openCreate() {
            this.$refs.modal.openCreate();
        },
        openEdit() {
            if (this.checkedRows.length === 1) {
                this.$refs.modal.openEdit(this.checkedRows[0]);
            }
        },
        refresh() {
            this.$refs.queryView.queryRows();
            // queryRows 不重算总数：新增 / 删除后分页总数要靠 countRows 刷新
            this.$refs.queryView.countRows();
        },
        viewCurve(row) {
            this.$router.push({path: '/sithMes/tpm/opcPointCurve', query: {recordId: String(row.id)}});
        },
        deleteChecked() {
            const rows = this.checkedRows.slice();
            if (!rows.length) {
                return;
            }
            this.$bvModal.msgBoxConfirm(this.$t('label.sith.tpm.furnaceHeatOrder.deleteConfirm', {count: rows.length}), {
                title: this.$t('title.sithMes.tpm.furnaceHeatOrder'),
                okTitle: this.$t('label.sith.tpm.furnaceHeatOrder.delete'),
                okVariant: 'danger',
                cancelTitle: this.$t('label.sith.tpm.furnaceHeatOrder.cancel'),
                centered: true
            }).then(yes => {
                if (!yes) {
                    return;
                }
                this.deleting = true;
                // 逐条删：不用 query string 传 id 列表（memory mmf-batch-request-header-limit）
                return rows.reduce((p, row) => p.then(() => deleteRecord(this.$store, row.id)), Promise.resolve())
                    .then(() => {
                        this.$bvToast.toast(this.$t('label.sith.tpm.furnaceHeatOrder.deleted', {count: rows.length}), {
                            title: this.$t('title.sithMes.tpm.furnaceHeatOrder'), variant: 'success', solid: true
                        });
                    })
                    .finally(() => {
                        this.deleting = false;
                        this.refresh();
                    });
            }).catch(() => {
            });
        }
    }
};
</script>
